var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-deleteDialog',{attrs:{"noPrevention":"","resource":"folder"},on:{"cancel":_vm.handleCancel,"delete":_vm.rmdir},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }